/** Единый список тегов кеша. Новый домен — новая строка здесь. */
export const API_TAGS = [
  'Session',
  'Company',
  'Invitation',
  'RegistrationRequest',
  'User',
  'Product',
  'CatalogSearch',
  'SupplierPrice',
  'OrderCatalog',
  'PcBuild',
  'Category',
  'Cart',
  'ManagerCart',
  'Order',
  'Command',
  'Exchange',
  'Serial',
  'Shipment',
  'Client',
  'Stock',
  'Payment',
  'WarrantyTicket',
  'Report',
  'Notification',
  'Dialog',
  'Message',
] as const

export type ApiTag = (typeof API_TAGS)[number]

/** Теги для списка: общий LIST + по элементу. */
export function providesList<T extends { id: string }>(
  items: T[] | undefined,
  tag: ApiTag,
): { type: ApiTag; id: string }[] {
  return [{ type: tag, id: 'LIST' }, ...(items ?? []).map((item) => ({ type: tag, id: item.id }))]
}
